import { t } from 'i18next';

export const returnSharedFields = (t, portion = '', upperCaseLang = 'EN') => {
  return {
    contractNo: {
      label: t('CONTRACT_NO'),
      id: 'ContractNo'
    },
    contractDesc: {
      label: t('CONTRACT_DESC'),
      id: `ContractDesc${upperCaseLang}`
    },
    contractor: {
      label: t('CONTRACTOR'),
      id: `ContractorName${upperCaseLang}`
    },

    bcType: {
      label: t('BC_TYPE'),
      id: 'Bctype'
    },
    tagId: {
      label: t('TAG_ID'),
      id: 'TagId'
    },
    rfidTagNo: {
      label: t('RFID_TAG_NO'),
      id: 'RfidtagNo'
    },
    productNo: {
      label: t('PRODUCT_NO'),
      id: 'ProductNo'
    },
    cate: {
      label: t('CATEGORY'),
      id: 'Category',
      type: 'select'
    },
    subCate: {
      label: t('SUB_CATEGORY'),
      id: 'Subcategory',
      type: 'select'
    },
    workingNo: {
      label: t('WORKING_NO'),
      id: 'WorkingNo'
    },
    asn: {
      label: 'A.S.N.',
      id: 'ASN'
    },
    hingeSupplier: {
      label: t('HINGE_SUPPLIER'),
      id: `SupplierName${upperCaseLang}`,
      type: 'select'
    },
    rsCompany: {
      label: t('RS_COMPANY'),
      type: 'select',
      id: `RSCompanyName${upperCaseLang}`
    },
    rsinspectionDate: {
      label: t('INSPECT_DATE'),
      id: 'RsinspectionDate',
      type: 'dateTimePicker'
    },
    internalFinishDate: {
      label: t('INTERNAL_FINISH_DATE'),
      id: 'InternalFinishDate',
      type: 'dateTimePicker'
    },
    waterproofingInstallationDate: {
      label: t('WATERPROOF_INSTALLATION_DATE'),
      id: 'InternalFinishDate',
      type: 'dateTimePicker'
    },
    castingDate: {
      label: t('CASTING_DATE'),
      id: 'CastingDate',
      type: 'dateTimePicker'
    },
    firstCastingDate: {
      label: t('FIRST_CASTING_DATE'),
      id: 'FirstCastingDate',
      type: 'dateTimePicker'
    },
    secondCastingDate: {
      label: t('SECOND_CASTING_DATE'),
      id: 'SecondCastingDate',
      type: 'dateTimePicker'
    },
    manufacturer: {
      label: t('MANUFACTURER'),
      id: `ManufacturerName${upperCaseLang}`
    },
    manufacturerAddress: {
      label: t('MANUFACTURERS_ADDRESS'),
      id: `ManufacturerAddress${upperCaseLang}`
    },
    manuDate: {
      label: t('MANUF_DATE'),
      id: 'ManufacturingDate',
      type: 'dateTimePicker'
    },
    concreteGrade: {
      label: t('CONCRETE_GRADE'),
      id: 'ConcreteGrade',
      type: 'select'
    },
    serialNo: {
      label: t('SERIAL_NO'),
      id: 'SerialNo'
    },
    licensePlateNo: {
      label: t('LICENSE_PLATE_NO'),
      id: 'LicensePlateNo'
    },

    remark: {
      label: t('REMARK'),
      id: `Remark${portion}`
    },

    chipFailureSA: {
      label: t('CHIP_FAILURE_SA'),
      id: 'ChipFailureSa',
      type: 'checkbox'
    },
    chipFailureSI: {
      label: t('CHIP_FAILURE_SI'),
      id: 'ChipFailureSi',
      type: 'checkbox'
    },
    deliveryDate: {
      label: t('DELIVERY_DATE'),
      id: 'DeliveryDate',
      type: 'dateTimePicker'
    },
    batchNo: {
      label: t('BATCH_NO'),
      id: 'BatchNo'
    },
    GpsDeviceId: {
      label: t('GPS_DEVICE_ID'),
      id: 'GpsDeviceId'
    },
    arrivalDate: {
      label: t('SITE_ARRIVAL_DATE'),
      id: 'SiteArrivalDate',
      type: 'dateTimePicker'
    },
    installDate: {
      label: t('INSTALLATION_DATE'),
      id: 'SiteInstallationDate',
      type: 'dateTimePicker'
    },
    waterproofInstallDate: {
      label: t('WATERPROOF_INSTALLATION_DATE'),
      id: 'WaterproofingInstallationDate',
      type: 'dateTimePicker'
    },
    block: {
      label: t('BLOCK'),
      id: 'Region',
      type: 'select'
    },
    floorNo: {
      label: t('FLOOR'),
      id: 'Floor',
      type: 'select'
    },
    unit: {
      label: t('UNIT'),
      id: 'RoomNo',
      type: 'select'
    },
    roomInput: {
      label: t('ROOM_INPUT'),
      id: 'RoomInput'
    },

    dispose: {
      label: t('DISPOSE'),
      id: 'Dispose',
      type: 'checkbox'
    },
    isCompleted: {
      label: t('IS_COMPLETED'),
      id: `IsCompleted${portion}`,
      type: 'checkbox'
    }
  };
};
